"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const components_1 = require("./../../../../components");
const Input_1 = require("./Input");
class VerticalFormFieldInput extends react_1.PureComponent {
    render() {
        const _a = this.props, { className, helpText, id, label, name, success, successMessage, value } = _a, otherProps = __rest(_a, ["className", "helpText", "id", "label", "name", "success", "successMessage", "value"]);
        const labelId = `label-for-${name}`;
        return (React.createElement(components_1.FormGroup, { "aria-labelledby": labelId, "aria-describedby": name },
            React.createElement(components_1.Label, { className: "form-control-label", id: labelId, for: name }, label),
            React.createElement(Input_1.Input, Object.assign({ name: name, id: name, value: value }, otherProps)),
            success && (React.createElement(components_1.FormFeedback, null, successMessage)),
            !!helpText && (React.createElement(components_1.FormText, { tag: "span", color: "muted" }, helpText))));
    }
}
exports.VerticalFormFieldInput = VerticalFormFieldInput;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/InputText/VerticalFormFieldInput.tsx
// module id = 239
// module chunks = 0